import { jsxs as t, jsx as e } from "react/jsx-runtime";
import { TextSkeleton as S } from "../../../../components/TextSkeleton/index.js";
import { ContainerSkeleton as d, ImageSkeleton as i, Content as k, TitleSkeletonContainer as c, HeaderSkeleton as h, StoreSkeleton as n, TimeStampSkeleton as r, TitleSkeleton as p, FooterSkeleton as C, StampSkeleton as f, DealShareButtonSkeleton as a, BottomContainer as s, VoteCommentSkeletonContainer as u, DealCardButtonSkeleton as B } from "./style.js";
import { ActionsSkeleton as D } from "../DealSavedCard/style.js";
import { DealVoteButtonSkeleton as x, DealCommentButtonSkeleton as T } from "../../DealVoteButton/style.js";
const y = ({
  animate: l,
  className: m,
  keepMobileLayout: o = !1
}) => /* @__PURE__ */ t(
  d,
  {
    animate: l,
    className: m,
    "data-keep-mobile-layout": o,
    children: [
      /* @__PURE__ */ e(i, { "data-keep-mobile-layout": o }),
      /* @__PURE__ */ t(k, { "data-keep-mobile-layout": o, children: [
        /* @__PURE__ */ t(c, { children: [
          /* @__PURE__ */ t(h, { "data-keep-mobile-layout": o, children: [
            /* @__PURE__ */ e(n, {}),
            /* @__PURE__ */ e(r, {})
          ] }),
          /* @__PURE__ */ t(p, { "data-keep-mobile-layout": o, children: [
            /* @__PURE__ */ e(S, { width: "60%" }),
            /* @__PURE__ */ e(r, {})
          ] })
        ] }),
        /* @__PURE__ */ t(C, { "data-keep-mobile-layout": o, children: [
          /* @__PURE__ */ e(f, {}),
          /* @__PURE__ */ e(n, {}),
          /* @__PURE__ */ e(a, { animate: l })
        ] })
      ] }),
      /* @__PURE__ */ e(D, { children: /* @__PURE__ */ t(s, { children: [
        /* @__PURE__ */ t(
          u,
          {
            "data-keep-mobile-layout": o,
            children: [
              /* @__PURE__ */ e(x, { animate: l }),
              /* @__PURE__ */ e(T, { animate: l }),
              /* @__PURE__ */ e(a, { animate: l })
            ]
          }
        ),
        /* @__PURE__ */ e(B, { animate: l })
      ] }) })
    ]
  }
);
export {
  y as DealCardSkeleton
};
